module.exports = __webpack_public_path__ + "static/media/MLCC.c063bafe.png";